import Devarajan from "../assets/ceos/Devarajan.png";
import Anup from "../assets/ceos/Anup.jpeg";
import Manish from "../assets/ceos/Manish.png";
import Tapobrat from "../assets/ceos/Tapobrat.jpg";
import Shwetha from "../assets/ceos/Shwetha.png";
import Shripad from "../assets/ceos/Shripad.png";
export const teamData = {
  page: [
    {
      title: "Ceo",
      sections: [
        {
          name: "Devarajan Kannan ",
          role: "Director and Chairman",
          image: Devarajan,
          title: "Director and Chairman",
          paragraphs: [
            "In his little more than three decades at Kotak Mahindra Group, D Kannan has spearheaded various businesses. In 1991, he joined Kotak Mahindra Finance Ltd. as Assistant Manager. Thereafter, he was elevated to Vice President - Field Operation, Ford Credit Kotak Mahindra Ltd. with the responsibility of its Sales & Marketing functions.",
            "Kannan moved to Kotak Securities Ltd in 2000. He set up kotaksecurities.com - the online trading and stock market advisory platform of the retail brokerage business. Prior to taking charge of the Commercial Banking business, Kannan was Managing Director (MD), Kotak Securities Ltd. Prior to his elevation as MD of Kotak Securities, he was the company’s Executive Director.",
            "Kannan was heading one of the Strategic Business Units (SBU) of Kotak Mahindra Bank - the Commercial Banking business from August 2014 to July 2022. Kannan was part of the Bank’s Group Management Council that drives and oversees Kotak Mahindra Group’s growth charter.",
            "Mr.Devarajan is a commerce graduate from Bangalore University, Chartered Accountant(CA), and Cost and Works Accountant(CWA).",
          ],
        },
        {
          name: "Anup Kumar Singh ",
          role: "Managing Director & Chief Executive Officer",
          image: Anup,
          title: "Technical Mastery",
          paragraphs: [
            "Mr. Anup Kumar Singh, a pioneer in India’s microfinance sector with over 28 years of rich experience, has been appointed as the Managing Director and CEO of BSS Sonata Microcredit Limited, following the merger of Sonata Finance Private Limited under BSS Microfinance Limited.",
            "Mr. Singh, who founded Sonata Finance in 2006, has been instrumental in transforming it into one of Uttar Pradesh’s leading microfinance institutions through his visionary leadership and deep commitment to financial inclusion.",
            "With extensive training from the renowned Grameen Bank in Bangladesh and academic credentials including a Master’s in Economics & Sociology, a Postgraduate Diploma in Rural Development and Management, and an MBA in Finance, Mr. Singh brings a unique blend of expertise and empathy to his role. He now envisions steering BSS Sonata Microcredit Limited toward becoming a one-stop solution for customers’ financial needs—strengthening its position as a trusted financial counsellor and enabler of socio-economic empowerment for millions.",
          ],
        },
        
        {
          name: "Shwetha Kalappa ",
          role: "Director",
          image: Shwetha,
          paragraphs: [
            "Shwetha Kalappa is a Talent Engagement Champion with over two decades of expertise in balancing strategic intent with operational excellence. She has extensive experience in the BFSI sector having lead the integration of people, process and technology of HR in two of the biggest mergers in the industry. Has led the various facets of HR as COE, Business Partner and Shared Services. Adept at leading global projects, currently lead the employee experience, and HR digital transformation journey across Kotak Mahindra Bank.",
            "As HR Automation Head - oversee the strategy and implementation of all IT transformation projects in HR. - Worklife App, K Applaud & Eureka are some properties launched and had 80% adoption within 3 months.",
            "As Employee Engagement Head several programs launched as flagship programs – Young Leader Council, Health & Wellness-Fitness Allowance. Kotakathon to engage employees deliver innovative solutions to enhance customer experience, Infinity Awards, Foundation Day event saw 25000 in audience in a virtual event. Wellness & Covid Support programs across group.",
            "Led the HR process, policy and people integration from ING during merger with Kotak.",
          ],
        },
         {
          name: "Shripad Krishnarao Jadhav ",
          role: "Director",
          image: Shripad,
          paragraphs: [
            "Mr. Shripad Krishnarao Jadhav is a seasoned banking professional and currently serves as President & Head – Bharat Banking Assets at Kotak Mahindra Bank. He brings close to three decades of experience in financial services, with deep expertise in agriculture, rural and priority sector lending. He has been associated with Kotak Mahindra Bank since over two decades, where he has held multiple leadership roles across agricultural and rural banking.",
            "Prior to joining Kotak, he began his career with Mahindra & Mahindra in 1995 after completing his Master of Financial Management, where he gained strong exposure to the agricultural and tractor financing ecosystem. Over the years, he has played a key role in expanding Kotak’s rural lending franchise and driving financial inclusion through innovative and technology-enabled solutions tailored to India’s Bharat segment.",           
          ],
        },
      ],
    },
    {
      title: "Team Members",
      sections: [
        {
          id: 1,
          name: "Devarajan Kannan",
          department: "Executive Leadership",
          role: "Director and Chairman",
          image: Devarajan,
          title: "Director and Chairman",
          paragraphs: [
            "In his little more than three decades at Kotak Mahindra Group, D Kannan has spearheaded various businesses. In 1991, he joined Kotak Mahindra Finance Ltd. as Assistant Manager. Thereafter, he was elevated to Vice President - Field Operation, Ford Credit Kotak Mahindra Ltd.",
            "Kannan moved to Kotak Securities Ltd in 2000. He set up kotaksecurities.com - the online trading and stock market advisory platform of the retail brokerage business.",
            "Mr. Devarajan is a commerce graduate from Bangalore University, Chartered Accountant (CA), and Cost and Works Accountant (CWA).",
          ],
        },
        {
          id: 2,
          name: "Anup Mehta",
          department: "Finance Department",
          role: "Chief Financial Officer",
          image: Anup,
          title: "Chief Financial Officer",
          paragraphs: [
            "Anup brings over 20 years of experience in corporate finance, accounting, and strategic planning. He has led multiple successful financial transformations across global teams.",
            "Before joining the company, he worked with Deloitte and PwC in leadership positions, managing audit and compliance for Fortune 500 clients.",
            "Anup holds an MBA in Finance and is a Certified Chartered Accountant.",
          ],
        },
        {
          id: 3,
          name: "Manish Sharma",
          department: "Operations Department",
          role: "Head of Operations",
          image: Manish,
          title: "Head of Operations",
          paragraphs: [
            "Manish has over 15 years of experience in optimizing business operations and developing high-performance teams.",
            "He specializes in process automation, efficiency improvements, and end-to-end project delivery.",
            "He holds a Bachelor's degree in Industrial Engineering and an Executive MBA in Operations Management.",
          ],
        },
        {
          id: 4,
          name: "Tapobrat Sen",
          department: "Technology Department",
          role: "Chief Technology Officer",
          image: Tapobrat,
          title: "Chief Technology Officer",
          paragraphs: [
            "Tapobrat oversees the company's technology vision, driving innovation and digital transformation initiatives.",
            "He has more than 18 years of experience in full-stack development, cloud computing, and AI-driven systems.",
            "Tapobrat holds a Master's degree in Computer Science and is passionate about building scalable and sustainable tech solutions.",
          ],
        },
        {
          id: 5,
          name: "Shwetha Nair",
          department: "Human Resources Department",
          role: "Head of Human Resources",
          image: Shwetha,
          title: "Head of Human Resources",
          paragraphs: [
            "Shwetha leads the HR strategy, talent acquisition, and employee engagement programs across the organization.",
            "She has over 12 years of experience in managing people-centric initiatives that promote culture, diversity, and leadership development.",
            "Shwetha holds a Postgraduate Diploma in Human Resource Management and is certified in Organizational Leadership.",
          ],
        },
      ],
    },
  ],
};
